import {useEffect, useState} from 'react'
import DeckApi from '../logic/DeckApi'
import {Deck} from '../model/models'
import {useNavigate} from 'react-router-dom'
import DeckMasonry from './DeckMasonry'
import {useSnackbar} from 'notistack'
import LoadingBackdrop from './LoadingBackdrop'

const api = new DeckApi()

export default function LimitedPublicDecks({isAnon, onAddPublicDeck}: {isAnon: boolean, onAddPublicDeck: VoidFunction}) {
  const [loading, setLoading] = useState<boolean>(true)
  const [loadingOverlay, setLoadingOverlay] = useState<boolean>(false)
  const [decks, setDecks] = useState<Deck[]>([])
  const {enqueueSnackbar} = useSnackbar()
  const navigate = useNavigate()
  
  const handleAddPublicDeck = async (deckId: number) => {
    if(loadingOverlay) return
    setLoadingOverlay(true)
    
    const res = await api.copyDeck(deckId)
    if (res.isError()) {
      setLoadingOverlay(false)
      console.error('error copying deck', res.exception?.toJson())
      enqueueSnackbar('Error copying deck', {variant: 'error'})
      return
    }
    
    enqueueSnackbar('Copied deck', {variant: 'success'})
    onAddPublicDeck()
  }
  
  useEffect(() => {
    let isCancelled = false
    
    api.getPublicDecksWithoutCards().then(decksResponse => {
      if (decksResponse.isError()) {
        console.error('error getting decks', decksResponse.exception?.toJson())
        navigate('/error')
        return
      }
      setDecks(decksResponse.data!)
    }).finally(() => {
      if (!isCancelled) setLoading(false)
    })
    
    return () => {
      isCancelled = true
    }
  }, [])
  
  return (
    <>
      <LoadingBackdrop loading={loadingOverlay}/>
      <DeckMasonry
        title="Public Decks"
        decks={decks} isPublic={true}
        onAddPublic={handleAddPublicDeck}
        isLimited
        loading={loading}
        isAnon={isAnon}
      />
    </>
  )
}
